import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { calendarSpecialtyConsultationWebList } from "../../../../../../../services/calendarSpecialtyConsultationWeb.service";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedMessages.";

export const ReceivedCaleSpecialties = memo(() => {
  const { t } = useTranslation();

  const { sendRequest: specialtyRequest } = useFetch(
    calendarSpecialtyConsultationWebList,
  );

  const [optionsSpecialty, setOptionsSpecialty] = useState<ISelectType[]>([]);

  const params = useMemo(() => {
    return {
      EnableCode: true,
      EnableCodeCalendar: true,
      ShowAppAndOnlineCalendar: true,
    };
  }, []);

  const fetchTicketAutomationReceivedCaleSpecialties = useCallback(async () => {
    const { data, success } = await specialtyRequest(params);
    if (data && success) {
      setOptionsSpecialty(
        data.map((d) => ({
          id: d.identifier.toString(),
          name: d.name,
        })),
      );
    }
  }, [specialtyRequest]);

  useEffect(() => {
    fetchTicketAutomationReceivedCaleSpecialties();
  }, [fetchTicketAutomationReceivedCaleSpecialties]);

  return (
    <Grid item xs={12} sm={12}>
      <AutoCompleteMulti
        params={params}
        fullWidth
        options={optionsSpecialty}
        name="calendarSpecialties"
        label={t(translationPath + "calendar_specialties")}
        getOptionLabel={(option) => option.name}
        size="small"
        keepOpenOnSelect
      />
    </Grid>
  );
});
